export default __webpack_public_path__ + "static/image-42-e59ca7d43931324608c0d710cd6af75a.jpg";